import { Spin as AntSpin } from "antd";
import * as React from "react";
import "./style.scss";

export interface SpinProps {
  size?: "small" | "default" | "large";
}
export class Spin extends React.Component<SpinProps, {}> {
  render() {
    return <AntSpin tip={"Loading..."} size={this.props.size || null} />;
  }
}



// WEBPACK FOOTER //
// ./client/modules/core/Spin/index.tsx